<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaValidacionesTickets"
      :titulo="$t ('Validaciones de tickets')"
      icono="mdi-star-check"
      tabla="valtic"
      :campos="['fechor+', 'id_ins', 'id_empinq', 'id_ope-', 'codcob-', 'numfac-', 'numpro+', 'mat', 'fechorent', 'imptotsindes-', 'impdes-', 'impbasimp-', 'impimp-', 'imptot', 'obs']"
      :campos-filtrables="['fechor', 'id_ins', 'id_empinq']"
      :parametros="parametros"
      busqueda-rapida
      permitir-modificar
    >
      <template v-slot:derecha-titulo>
        <v-btn small rounded color="primary" dark class="ml-3 mr-2 mt-n2" @click="validarTicket">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </template>

      <template v-slot:debajo-titulo>
        <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" style="width: 100%" mobile-breakpoint="0" @change="actualizarTabla">
          <v-tab v-for="tab in arrayTabs" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
        </v-tabs>
      </template>

      <template v-slot:[`item.mat`]="{ item }">
        <template v-if="item.mat">
          <span class="matricula">{{ item.mat }}</span>
        </template>
      </template>

    </TablaDatosAPI>

    <VentanaValidarTicket ref="vvt" />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import VentanaValidarTicket from "@/components/VentanaValidarTicket.vue";

export default {
  components: { TablaDatosAPI,
                VentanaValidarTicket },
  data: () => ({
    arrayTabs: [
      { titulo: "Hoy", icono: "", parametro: "filtroHoy" },
      { titulo: "Ayer", icono: "", parametro: "filtroAyer" },
      { titulo: "Este mes", icono: "", parametro: "filtroEsteMes" },
      { titulo: "El mes pasado", icono: "", parametro: "filtroElMesPasado" },
      { titulo: "(Todas)", icono: "", parametro: "" },
    ],
    tabSeleccionado: 0,
  }),
  computed: {
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    }
  },
  methods: {
    actualizarTabla() {
      this.$nextTick (() => {
        this.$refs.tablaValidacionesTickets.actualizarDatosPorCambiosEnBusqueda();
      });
    },
    validarTicket () {
      this.$refs.vvt.abrirVentana (this.$sagabroker, this.$refs.tablaValidacionesTickets);
    }
  },
  created() {
    this.tabSeleccionado = this.$store.leer_preferencia ('tabSeleccionado', 0, 'validacion_tickets');
  },
  watch: {
    tabSeleccionado() {
      this.$store.guardar_preferencia ('tabSeleccionado', this.tabSeleccionado, 0, 'validacion_tickets');
    }
  }
};
</script>

<style>
</style>